module.exports = __webpack_public_path__ + "static/bg-471cd2aed444f1f536a852f0cb07e4be.png";